import React from 'react';
import {
  makeStyles,
  Box,
  Button,
} from '@material-ui/core';
import HeaderAndDescription from 'common/components/HeaderAndDescription';
import Link from 'components/shared/Link';

const useStyles = makeStyles((theme) => ({
  textBox: {
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.grey['100']}`,
    borderRadius: 8,
  },
  upper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  left: {
    flexGrow: '1',
    display: 'flex',
    alignItems: 'flex-start',
  },
  btn: {
    textDecoration: 'underline',
    marginLeft: theme.spacing(3),
  },
}));

const TextBox = (props) => {
  const classes = useStyles();
  const {
    children, icon, iconColor, title, price, description, btnText, btnOnClick, btnPath,
  } = props;

  return (
    <>
      <Box className={classes.textBox}>
        <Box className={classes.upper}>
          <Box className={classes.left}>
            <HeaderAndDescription
              icon={icon}
              iconColor={iconColor}
              title={title}
              price={price}
              description={description}
            />
          </Box>

          {btnText && (
          <Button
            color="primary"
            onClick={btnOnClick}
            className={classes.btn}
            component={btnPath ? Link : 'button'}
            href={btnPath}
          >
            {btnText}
          </Button>
          )}
        </Box>

        {children}
      </Box>
    </>
  );
};

export default TextBox;
